//css,js読み込み
import "./scss/style.scss";
import "./scss/page.scss";


//////
//高さ調整js
//////
let windowW = window.innerWidth;
let windowH = window.innerHeight;

function changeHeight() {
  const newWindowW = window.innerWidth;
  const newWindowH = window.innerHeight;

  // 幅か高さが変わった場合のみ更新
  if (newWindowW !== windowW || newWindowH !== windowH) {
    document.documentElement.style.setProperty('--vh', `${newWindowH * 0.01}px`);
    windowW = newWindowW;
    windowH = newWindowH;
  }
}



changeHeight();

let timer = null;
window.addEventListener('resize', () => {
  if (timer !== null) clearTimeout(timer);

  timer = setTimeout(() => {
    changeHeight();
  }, 100);
});





//関数雨使用したい場合
//import { disableScroll,enableScroll,lockScroll } from "./js/menu.js";




import "./js/menu.js"; // メニュー






//エントリートグル
document.querySelectorAll('.etBtn').forEach((btn) => {
  btn.addEventListener('click', () => {
    const box = btn.nextElementSibling;
    if (box && box.classList.contains('etBox')) {
      box.classList.toggle('on');
    }
  });
});




//スクロールアニメ
function setAction() {
  const scrollTop = window.scrollY;
  const winH = window.innerHeight;



  // .sec
  document.querySelectorAll('.sec').forEach((el) => {
    const th = el.getBoundingClientRect().top + scrollTop;
    if (scrollTop > (th - winH * 0.8)) {
      el.classList.add('on');
    }
  });


}

window.addEventListener('scroll', setAction);
window.addEventListener('load', setAction);




//ページ遷移

document.addEventListener('DOMContentLoaded', () => {

  const getOffset = () => {
    return window.innerWidth <= 860 ? 100 : 280;
  };

  // スクロール復元OFF
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // =========================
  // クリック処理
  // =========================
  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {

      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      const url = new URL(href, location.href);

      // -------------------------
      // 同一ページ内
      // -------------------------
      if (url.pathname === location.pathname) {
        e.preventDefault();
        scrollToAnchor(url.hash);

        // URL更新
        history.pushState(null, '', url.hash);
        return;
      }

      // -------------------------
      // 別ページ遷移
      // -------------------------
      if (url.hash) {
        e.preventDefault();

        // ★ ハッシュ保存
        sessionStorage.setItem('scrollTarget', url.hash);

        // ★ ハッシュを外して遷移（ここ重要）
        location.href = url.pathname + url.search;
      }
    });
  });

  // =========================
  // 遷移後処理
  // =========================
  const savedHash = sessionStorage.getItem('scrollTarget');

  if (savedHash) {
    sessionStorage.removeItem('scrollTarget');

    // ★ 必ずトップからスタート
    window.scrollTo(0, 0);

    // ★ load後に確実にスクロール
    window.addEventListener('load', () => {
      setTimeout(() => {
        scrollToAnchor(savedHash);
      }, 200);
    });
  }

  // =========================
  // スクロール関数
  // =========================
  function scrollToAnchor(hash) {
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    const position = target.getBoundingClientRect().top + window.pageYOffset - getOffset();

    window.scrollTo({
      top: position,
      behavior: 'smooth'
    });
  }

});




//ヘッダー挙動
let lastScrollY = window.scrollY;
const header = document.querySelector('header');

window.addEventListener('scroll', () => {
  const currentScrollY = window.scrollY;

  if (currentScrollY > lastScrollY) {
    // 下スクロール
    header.classList.add('down');
  } else {
    // 上スクロール
    header.classList.remove('down');
  }

  lastScrollY = currentScrollY;
});












import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", () => {
  // ティッカー：コンテンツ幅に応じてdurationを計算し一定速度を保つ
  const TICKER_PX_PER_SEC = 120; // px/秒（この値で速さを調整）
  document.querySelectorAll('.ticker__track').forEach(track => {
    const oneSpan = track.querySelector('span');
    if (!oneSpan) return;
    const contentWidth = oneSpan.offsetWidth;
    const duration = contentWidth / TICKER_PX_PER_SEC;
    track.style.setProperty('--ticker-duration', `${duration}s`);
  });

  // Our Line スライダー
  const swiperEl = document.querySelector('.ourline__swiper');
  if (swiperEl) {


    new Swiper('.ourline__swiper', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        480: {
          centeredSlides: false,
          slidesPerView: 2.5,
          spaceBetween: 24,
        },
        860: {
          centeredSlides: false,
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
        1180: {
          centeredSlides: false,
          slidesPerView: 4.5,
          spaceBetween: 24,
        }
      }
    });
  }
  // job__swiper スライダー
  var swiperJob = document.querySelector('.job__swiper');
  if (swiperJob) {
    new Swiper('.job__swiper', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        1180: {
          centeredSlides: false,
          slidesPerView: 1,
          spaceBetween: 24
        }
      }
    });
  }
});



// pepoleAcv__Slide スライダー（自動スクロール＋ドラッグ）
document.addEventListener('DOMContentLoaded', () => {
  const pepoleSlide = document.querySelector('.pepoleAcv__Slide');
  if (pepoleSlide) {
    let startX = 0;
    let hasMoved = false;

    pepoleSlide.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      hasMoved = false;
    });

    pepoleSlide.addEventListener('pointermove', (e) => {
      if (!hasMoved && Math.abs(e.clientX - startX) > 5) {
        hasMoved = true;
      }
    });

    pepoleSlide.addEventListener('click', (e) => {
      if (hasMoved) {
        e.preventDefault();
        hasMoved = false;
      }
    }, true);

    new Swiper('.pepoleAcv__Slide', {
      loop: true,
      grabCursor: true,
      speed: 600,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 2,
      spaceBetween: 0,
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        860: {
          slidesPerView: 3.5,
          spaceBetween: 24,
          centeredSlides: true,
        },
        1180: {
          slidesPerView: 4,
          spaceBetween: 24,
          centeredSlides: true,
        },
      },
      on: {
        sliderFirstMove: (swiper) => {
          swiper.el.classList.add('is-sliding');
        },
        transitionEnd: (swiper) => {
          swiper.el.classList.remove('is-sliding');
        },
      },
    });
  }
});
